"use client";

import Image from "next/image";
import React, { useState } from 'react';
import RevenueLossCalculator from '@/components/blocks/revenue-loss-calculator';
import { Button } from "../ui/button";

const Hero: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <section className="relative bg-gradient-to-br from-indigo-50 via-white to-blue-50 h-100vh lg:h-[92vh] flex items-center overflow-hidden py-12">
                <div className="container mx-auto px-6">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div className="text-center md:text-left">
                            <h1 className="text-4xl md:text-6xl font-extrabold text-slate-800 leading-snug mb-6">
                                Telephony <br />Voice AI Agent
                            </h1>
                            <div className="text-lg text-gray-600 mb-8 max-w-xl mx-auto md:mx-0">
                                Automate phone calls. Every call answered. Every order captured. Every customer assisted. Your {' '}
                                <span className="scroll-text h-[1.6rem]">
                                    <div className="scroll-text-inner">
                                        <span>rules</span>
                                        <span>scripts</span>
                                        <span>data</span>
                                    </div>
                                </span>
                                , perfectly executed.
                            </div>
                            <Button variant="default" size="lg" onClick={() => setIsModalOpen(true)}>
                                Find out how much revenue you are losing
                            </Button>
                        </div>
                        <div className="relative">
                            <Image
                                src="/images/hero.jpg"
                                alt="Telephony Voice AI Agent on a tablet"
                                width={800}
                                height={600}
                                className="rounded-2xl shadow-2xl transform md:rotate-3"
                                priority
                                fetchPriority="high"
                            />
                            <div className="absolute -top-4 -right-4 w-12 h-12 md:-top-8 md:-right-8 md:w-24 md:h-24 bg-pink-400 rounded-full opacity-50 pulse"></div>
                            <div className="absolute -bottom-4 -left-4 w-16 h-16 md:-bottom-8 md:-left-8 md:w-32 md:h-32 bg-blue-400 rounded-full opacity-50 pulse delay-75"></div>
                        </div>
                    </div>
                </div>
            </section>
            {isModalOpen && <RevenueLossCalculator isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />}
        </>
    );
};

export default Hero;